import React from "react";
import { NavLink, useHistory } from "react-router-dom";

import { MobileSideNavWrapper } from "../../../AuthenticatedApp/layout/common/newMobileNav.styles";
import {
    Divider,
    InitialWrap,
    LogoutWrap,
    MobileNavItemStyled,
} from "../common/salesModeLayout.styles";
import { ReactComponent as CloseIcon } from "../../../AuthenticatedApp/layout/common/icons/white-close.svg";
import { navigationItems } from "./TopNavigation";
import { LogoutIcon } from "../../common/assets/icons/layoutIcons";
import { logout } from "../../../../utils/utilityFunctions";

const MobileNav = ({ handleToggleMobileNav }) => {
    const history = useHistory();

    const handleSignOut = () => {
        logout();
        window.location.reload();
        history.push("/login");
    };
    return (
        <div className="kuda-mobile--menu">
            <MobileSideNavWrapper>
                <div className="mobile-nav__top-section">
                    <InitialWrap>
                        <div className="sales__nav-initial-inner">
                            <p>O</p>
                        </div>
                    </InitialWrap>
                    <div className="ml-auto" onClick={() => handleToggleMobileNav(false)}>
                        <CloseIcon />
                    </div>
                </div>
                <MobileNavItemStyled>
                    {navigationItems.map(({ title, link }) => (
                        <NavLink
                            to={link}
                            className="mobile-nav__items"
                            activeClassName="mobile-nav__items-active"
                            key={"mobile-sales-link" + title}
                            onClick={() => handleToggleMobileNav(false)}
                        >
                            <p>{title}</p>
                        </NavLink>
                    ))}
                </MobileNavItemStyled>
                <Divider />
                <LogoutWrap onClick={handleSignOut}>
                    <LogoutIcon />
                    <p>Sign Out</p>
                </LogoutWrap>
            </MobileSideNavWrapper>
        </div>
    );
};

export default MobileNav;
